import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { ButtonContainer } from './elements';
import moment from 'moment';

import { CREATE_SALE, SALES_WITH_COUNT } from './queries';

import PreBidSchedulePicker from './PreBidSchedules/Picker';

const NewSale = ({setShowModal, refetch, fromNav}) => {
  const [submitting, setSubmitting] = useState();
  const [showSaleSelect, setShowSaleSelect] = useState();
  const [createSale] = useMutation(CREATE_SALE, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }else if(fromNav) {
        window.location.replace('/sales');
      }
      setShowModal(false);
    }
  });

  const { loading, error, data } = useQuery(
    SALES_WITH_COUNT, { variables: { } }
  );

  const onSubmit = useCallback(input => {
    input['preBidOpenAt'] =
      input['preBidOpenAt'] ?  moment(input['preBidOpenAt'])._d : null;
    input['startAt'] = moment(input['startAt'])._d;
    input['endAt'] = input['endAt'] !== '' ? moment(input['endAt'])._d : null;
    setSubmitting(true);
    createSale({ variables: input });
  });

  const {
    control, handleSubmit, register, watch, setValue, formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      saleOn: '',
      preBidOpenAt: '',
      startAt: '',
      endAt: '',
      status: 'Future',
      copyBuyerPaddles: false,
      copyBuyerPaddlesSaleId: '',
      saleType: '',
      initialTime: 300,
      retriggerTime: 30,
      addTime: 15,
    }
  });

  const watchCopyBuyerPaddles = watch('copyBuyerPaddles');
  const watchSaleType = watch('saleType');

  useEffect(() => {
    if(watchCopyBuyerPaddles) {
      setShowSaleSelect(true);
    }else {
      setShowSaleSelect(false);
    }
  }, [watchCopyBuyerPaddles])

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Picker
            label="Sale Type:"
            name="saleType"
            control={control}
            options={
              [
                {
                  value: "Live",
                  label: "Live Auction",
                },
                {
                  value: "Timed",
                  label: "Timed Event"
                },
              ]
            }
            {...register('saleType', { required: 'Required', })}
          />
          {(watchSaleType != '') &&
            <>
              <Input.Text
                label="Name:"
                name="name"
                control={control}
                errors={errors}
                {...register("name", {
                  required: "Required",
                })}
              />
              <Input.Date
                label="Sale Date:"
                name="saleOn"
                control={control}
                errors={errors}
                {...register('saleOn', { required: 'Required', })}
              />
              <Input.DateTime
                label="Start:"
                name="startAt"
                control={control}
                errors={errors}
                {...register("startAt", {
                  required: "Required",
                })}
              />
              <Input.DateTime
                label="End:"
                name="endAt"
                control={control}
                errors={errors}
              />
              <Input.DateTime
                label="Pre Bid Open At:"
                name="preBidOpenAt"
                control={control}
                errors={errors}
              />
              {(watchSaleType == 'Timed') &&
                <>
                  <Input.Number
                    label="Initial Time (in Seconds):"
                    name="initialTime"
                    control={control}
                    errors={errors}
                    {...register("initialTime")}
                  />
                  <Input.Number
                    label="Retrigger Time (in Seconds):"
                    name="retriggerTime"
                    control={control}
                    errors={errors}
                    {...register("retriggerTime")}
                  />
                  <Input.Number
                    label="Add Time (in Seconds):"
                    name="addTime"
                    control={control}
                    errors={errors}
                    {...register("addTime")}
                  />
                </>
              }
              <Input.StatusPicker
                label="Status:"
                name="status"
                control={control}
                errors={errors}
              />
              <Input.Checkbox
                label="Copy Buyer Paddles From Previous Sale?"
                name="copyBuyerPaddles"
                control={control}
                errors={errors}
              />
              {showSaleSelect &&
                <Input.Picker
                  label="Sale to Copy Buyer Paddles From:"
                  name="buyerPaddlesSaleId"
                  control={control}
                  options={
                    data?.salesWithCount.entries?.map(option => {
                      return {
                        value: option.id,
                        label: `${option.name} ${moment(option.saleOn).format('MM-DD-YYYY')}`
                      }
                    })
                  }
                />
              }
              <PreBidSchedulePicker
                control={control}
                errors={errors}
                saleOn={watch('saleOn')}
                setValue={setValue}
              />
              <ButtonContainer>
                <ButtonGroup>
                  <Button label="Create Sale" onPress={handleSubmit(onSubmit)} />
                </ButtonGroup>
              </ButtonContainer>
            </>
          }
          {(watchSaleType == '') &&
            <>
              Select a Sale Type to Continue
            </>
          }
        </View>
      }
    </View>
  )
}

export default NewSale;
